import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { SAVE_SUMMARY_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';

export const SUMMARISATION_STATUS_QUERY = 'get_summary_status';

export const useFetchSummarisationStatus = ({ deeplink }: FetchParams) => {
  return useQuery(
    [SUMMARISATION_STATUS_QUERY, deeplink],
    async ({ signal }) => {
      return await axiosInstance.get<Response>(
        SAVE_SUMMARY_API_ROUTES.status(),
        { params: { deeplink }, signal }
      );
    },
    {
      select: (data) => data.data.results,
      enabled: !!deeplink,
    }
  );
};

export const useInvalidateFetchSummarisationStatus = () => {
  const queryClient = useQueryClient();

  return React.useCallback(
    (deeplink: string) => {
      return queryClient.invalidateQueries([
        SUMMARISATION_STATUS_QUERY,
        deeplink,
      ]);
    },
    [queryClient]
  );
};

type FetchParams = {
  deeplink: string;
};

type Response = {
  results: Result;
};

type Result = {
  summary_pdf: string | null;
  status: 'FAILED' | 'PENDING' | 'PROCESSING' | 'SUCCESS';
};
